<template>
<div>
    {{ label }}
    <zm-tooltip class="item" placement="bottom" v-if="isAdmin || content">
        <div slot="content">
            <span>{{ content }}</span>
            <zm-button type="icon" icon="zm-icon-add" v-if="!hasTip && id" @click="showAdd"></zm-button>
            <zm-button type="icon" icon="zm-icon-edit" v-if="hasTip && isAdmin" @click="showEdit"></zm-button>
            <zm-button type="icon" icon="zm-icon-delete" v-if="hasTip && isAdmin" @click="showDelete"></zm-button>
        </div>
        <i :class="loading ? 'zm-icon-loading' : 'zm-icon-help-outline'"></i>
    </zm-tooltip>
    <zm-dialog append-to-body :visible.sync="formVisible" :title="hasTip ? 'Edit Tip' : 'Create Tip'">
        <zm-form label-width="80px">
            <zm-form-item label="US">
                <zm-input v-model="form.US"></zm-input>
            </zm-form-item>
            <zm-form-item label="CN">
                <zm-input v-model="form.CN"></zm-input>
            </zm-form-item>
        </zm-form>
        <div slot="footer" class="dialog-footer">
            <zm-button size="small" @click="formVisible = false">Cancel</zm-button>
            <zm-button size="small" type="primary" @click="save()" :loading="loading">Submit</zm-button>
        </div>
    </zm-dialog>
</div>
</template>
<script>
import {
    listTooltip,
    createTooltip,
    updateTooltip,
    deleteTooltip
} from '../../api/tip'
// import languages from '../../plugins/language'
export default {
    name: 'tooltip',
    props: ['label', 'id', 'tips'],
    data () {
        return {
            loading: false,
            isAdmin: localStorage.role === 'SUPER_ADMIN' || localStorage.role === 'ADMIN',
            // languages: languages,
            descriptions: localStorage.tips === {} ? {} : JSON.parse(localStorage.tips),
            selectedLan: 'US',
            hasTip: false,
            content: '',
            formVisible: false,
            form: {
                CN: '',
                US: ''
            }
        }
    },
    created () {
        this.content = this.tips || ''
        this.setTip()
    },
    watch: {
        id () {
            this.content = ''
            this.setTip()
        }
    },
    methods: {
        setTip () {
            if (this.id) {
                if (this.descriptions[this.id]) {
                    this.content = this.descriptions[this.id].content[this.selectedLan]
                    this.hasTip = true
                } else {
                    this.hasTip = false
                }
            }
        },
        showAdd () {
            this.formVisible = true
        },
        showEdit () {
            this.formVisible = true
            this.form.US = this.descriptions[this.id].content.US
            this.form.CN = this.descriptions[this.id].content.CN
        },
        showDelete () {
            this.$confirm('This will delete the tip. Continue?', 'Warning', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                deleteTooltip(this.id).then(() => {
                    this.loading = false
                    this.content = ''
                    this.fetchData()
                    this.$message.success('Delete success!')
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message.info('Delete canceled')
            })
        },
        save () {
            const data = {
                id: this.id,
                content: this.form
            }
            if (!this.hasTip) {
                this.loading = true
                createTooltip(data).then(() => {
                    this.formVisible = false
                    this.loading = false
                    this.fetchData()
                }).catch(() => {
                    this.loading = false
                })
            } else {
                this.loading = true
                updateTooltip(this.id, data).then(() => {
                    this.formVisible = false
                    this.loading = false
                    this.fetchData()
                }).catch(() => {
                    this.loading = false
                })
            }
        },
        fetchData () {
            listTooltip().then(response => {
                this.descriptions = response
                this.setTip()
                localStorage.tips = JSON.stringify(response)
            })
        }
    }
}
</script>
